import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import LoginPage from "./pages/login/index";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import VerifyOtpPage from "./pages/login/VerifyOtpPage";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import { PanelPage } from "./pages/panel/index";
import { ColorsPage } from "./pages/panel/color/index";
import { UsersPage } from "./pages/panel/users/index";
import { ProductsPage } from "./pages/panel/products/index";
import Brands from "./pages/panel/brands/Brands";
import { OrdersPage } from "./pages/panel/orders/OrderPage";
import { OrderDetailPage } from "./pages/panel/orders/OrderDetailPage";
import { InvoicesPage } from "./pages/panel/invoices/index";
import { CustomersPage } from "./pages/panel/customers/index";
import { QuotationStatusPage } from "./pages/panel/quotation-status/index";
import { SettingsPage } from "./pages/panel/settings/index";
import { SignatoriesPage } from "./pages/panel/signatories";
import ProtectedRoute from "./components/ProtectedRoute";
import PWAStatusBar from "./components/PWAStatusBar";
import { initInstallPrompt } from "./utils/pwaUtils";

// export const API_BASE_URL = "https://app.cogenttechsolutions.info/api/v1/"; // Change this to your backend URL
// export const API_BASE_URL = "https://app.cogenttechsolutions.info/api/v1/";


const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

/** Local dev uses localhost API; production builds must hit the deployed API (not localhost). */
export const API_BASE_URL = isLocalHost
  ? "http://localhost:30041/api/v1/"
  : "https://app.cogenttechsolutions.info/api/v1/";

function App() {
  const { authToken, id, role } = useSelector((state) => state.loginData || {});
  const isAuthenticated = authToken && id;

  // Initialize PWA features
  useEffect(() => {
    initInstallPrompt();
  }, []);

  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <PWAStatusBar />
      <Router>
        <Routes>
          {/* Root route - redirect based on auth status */}
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <Navigate to="/panel/orders" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />

          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/verifyotp" element={<VerifyOtpPage />} />
          <Route path="/resetpassword" element={<ResetPasswordPage />} />

          {/* Protected Routes */}
          <Route 
            path="/panel" 
            element={
              <ProtectedRoute>
                <PanelPage />
              </ProtectedRoute>
            }
          >
            <Route path="colors" element={<ColorsPage />} />
            {/* <Route path="products" element={<ProductsPage />} /> */}
            <Route path="products/list" element={<ProductsPage />} />
            <Route path="brands" element={<Brands />} />
            <Route path="users" element={role === "admin" ? <UsersPage /> : <Navigate to="/panel/orders" replace />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="quotation-status" element={<QuotationStatusPage />} />
            <Route path="signatories" element={role === "admin" ? <SignatoriesPage /> : <Navigate to="/panel/orders" replace />} />
            <Route path="settings" element={role === "admin" ? <SettingsPage /> : <Navigate to="/panel/orders" replace />} />
          </Route>

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
